export const SubjectActions = {
    GET_SUBJECT_DATA: "GET_SUBJECT_DATA",
    SET_SUBJECT_DATA: "SET_SUBJECT_DATA",
    // define other action types here
  };
  